import * as React from 'react';

import URI from 'jsuri';
import { compose } from 'recompose';

import Retracked from 'js/app/retracked';

import adsTracker from 'bundles/event-tracking/lib';
import DisableCrawlerIndexing from 'bundles/seo/components/DisableCrawlerIndexing';
import withMarketingConsent from 'bundles/user-consent/components/withMarketingConsent';

import 'css!bundles/unified-home-common/__styles__/index';

type PropsFromCaller = {
  children?: JSX.Element;
};

type PropsToComponent = PropsFromCaller;

const ConsumerPageWrapper = ({ children }: PropsToComponent) => {
  React.useEffect(() => {
    const referrer = new URI(document?.referrer);
    if (referrer.getQueryParamValue('authMode') === 'signup') {
      adsTracker.trackSignup();
    }
  }, []);

  return (
    <React.Fragment>
      {children}
      <DisableCrawlerIndexing />
    </React.Fragment>
  );
};

/**
 * @description This wrapper contains some generic page functionality for the consumer home page.
 */
export default compose<PropsToComponent, PropsFromCaller>(
  withMarketingConsent,
  Retracked.createTrackedContainer(() => ({
    namespace: {
      app: 'dashboard',
      page: 'main',
    },
  }))
)(ConsumerPageWrapper);
